export const DialogRule = {
    "getTransfersOptions":"getTransfersOptions",
    "transferCallToACD":"transferCallToACD",
    "transferCallToAgent":"transferCallToAgent",
    "transferCallToPhoneNumber":"transferCallToPhoneNumber",
    "assistedDialNumber":"assistedDialNumber",
    "assistedDialACD":"assistedDialACD",
    "assistedDialAgent":"assistedDialAgent",
    "AssistedTransferCallHangUp":"AssistedTransferCallHangUp",
    "TransferAssistedCall":"TransferAssistedCall",
    "UseMainCall":"UseMainCall",
    "UseSecondCall":"UseSecondCall",
    "HangUp":"HangUp",
    "Mute":"Mute",
    "Hold":"Hold",
    "DTMF":"DTMF",
    "sendClientChatMessage":"sendClientChatMessage",
    "getSupervisorsToChat":"getSupervisorsToChat",
    "getChatHistory":"getChatHistory",
    "UpdateDataCall":"UpdateDataCall",
    "getACDDispositions":"getACDDispositions",
    "getCampaignDispositions":"getCampaignDispositions",
    "disposeACDCall":"disposeACDCall",
    "disposeCampaingCall":"disposeCampaingCall",
    "GetCampaignsRelated":"GetCampaignsRelated",
    "GetDispositionsAndNumbers":"GetDispositionsAndNumbers",
    "reprogramCampaignCall":"reprogramCampaignCall",
    "reprogramAcdCall":"reprogramAcdCall",
    "DropFirstCall":"DropFirstCall",
    "DropSecondCall":"DropSecondCall",
    "MakeConference":"MakeConference",
    "LeaveConference":"LeaveConference",
    "getLastCallData":"getLastCallData",
    "getPhoneNumbers":"getPhoneNumbers",
    "recordingStopStart":"recordingStopStart",
    "hangUpAndLeaveMessage":"hangUpAndLeaveMessage",
    "Disposition":"Disposition",
    "GetIVRList":"GetIVRList",
    "IdleStart":"IdleStart",
    "GetAgentID":"GetAgentID",
    "GetUserName":"getUserName",
    "GetExtension":"GetExtension",
    "getDispositions":"getDispositions",
    "saveDisposition":"saveDisposition",
};



// WEBPACK FOOTER //
// ./src/BusinessRule/DialogRule.js